/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_Complete_Confirm_TitleInputs */

const en_task_reminders_complete_confirm_title = /** @type {(inputs: Task_Reminders_Complete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel pending reminders?`)
};

const pt_br2_task_reminders_complete_confirm_title = /** @type {(inputs: Task_Reminders_Complete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar lembretes pendentes?`)
};

/**
* | output |
* | --- |
* | "Cancel pending reminders?" |
*
* @param {Task_Reminders_Complete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_complete_confirm_title = /** @type {((inputs?: Task_Reminders_Complete_Confirm_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_Complete_Confirm_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_complete_confirm_title(inputs)
	return pt_br2_task_reminders_complete_confirm_title(inputs)
});